'use client';

import IconClose from '@/assets/icons/category-second-level/icon-close-circle.svg';
import IconArrowLeft from '@/assets/icons/profile-popup/icon-arrow-left.svg';

import IconArrowTagUser from '@/assets/icons/profile-popup/icon-tag-user.svg';

import React, { useEffect, useRef } from 'react';

import Input, { isValidPhoneNumber } from 'react-phone-number-input/input';

import { Button } from 'rsuite';

import styles from './cabinet.module.scss';

import { useMutation } from '@apollo/client';

import { useAuthStore } from '@/zustand/useAuth';

import { SEND_OTP_MUTATION } from '@/apollo/graphql/mutations/authMutations/otpMutations';
import { useTranslations } from 'next-intl';

interface PersonalCabinetProps {
  handleOpen: () => void;
  handleClose: () => void;
  isGuest?: boolean;
  setAuth?: () => void;
  authWrapper?: boolean;
}

const PersonalCabinet = ({
  handleOpen,
  handleClose,
  isGuest = false,
  setAuth,
  authWrapper = false,
}: PersonalCabinetProps) => {
  const cabinetRef = useRef<HTMLDivElement>(null);
  const setPhone = useAuthStore(state => state.setPhone);

  const [sendOtp, { loading }] = useMutation(SEND_OTP_MUTATION);

  const [value, setValue] = React.useState<string | undefined>();
  const t = useTranslations('Drawer.Sign-in');

  const handlePhoneBlur = () => {
    if (!value) return;
    const digits = value.replace(/\D/g, '');
    if (!digits.startsWith('998')) return;
    const nationalNumber = digits.slice(3, 12);
    const finalFormatted = `+998${nationalNumber}`;
    if (value !== finalFormatted) setValue(finalFormatted);
  };

  const handleSendOtp = async () => {
    if (!value || !isValidPhoneNumber(value)) {
      return;
    }

    try {
      const response = await sendOtp({ variables: { phone: value } });

      if (response.data?.sendOtp?.status) {
        setPhone(value);
        setAuth?.();
        handleOpen();
      } else {
        console.error('Ошибка отправки OTP:', response.data?.sendOtp?.errors);
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        cabinetRef.current &&
        !cabinetRef.current.contains(event.target as Node)
      ) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClose]);

  return (
    <div
      className={authWrapper ? styles.authWrapper : styles.cabinetWrapper}
      ref={cabinetRef}
    >
      <div className={styles.content}>
        {!isGuest ? (
          <button type="button" onClick={handleClose}>
            <IconArrowLeft />
          </button>
        ) : (
          <button onClick={handleClose} className={styles.iconClose}>
            <IconClose />
          </button>
        )}

        <div className={styles.texts}>
          <IconArrowTagUser />

          <h4>{t('personal-account')}</h4>

          <p>{t('helper-text')}</p>
        </div>

        <Input
          placeholder={t('phone-number')}
          value={value}
          country="UZ"
          withCountryCallingCode
          international
          maxLength={17}
          onChange={setValue}
          onBlur={handlePhoneBlur}
          className={styles.inputPhone}
          onKeyDown={(e: { key: string }) => {
            if (e?.key === 'Enter') handleSendOtp();
          }}
          error={
            value
              ? isValidPhoneNumber(value)
                ? undefined
                : 'Invalid phone number'
              : 'Phone number required'
          }
        />

        <Button
          type="button"
          className={`${styles.btn} ${value ? styles.activebtn : null}`}
          onClick={handleSendOtp}
          loading={loading}
          disabled={!value || !isValidPhoneNumber(value)}
        >
          {t('sign-in')}
        </Button>

        <p className={styles.info}>{t('text')}</p>
      </div>
    </div>
  );
};

export default PersonalCabinet;
